module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.notifications == []) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(_vm._s(_vm.web_texts.notifications))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.notifications,
      "paginate": true,
      "perPage": 10
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdb11c0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Notifications.vue
// module id = 567
// module chunks = 1